import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kiene-dokumente-overview',
    templateUrl: './dokumente-overview.component.html',
    styleUrls: ['./dokumente-overview.component.scss'],
})
export class DokumenteOverviewComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
